import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import ReactHtmlParser from 'react-html-parser';

import BookAuthorReview from 'rebook/apps/books/components/BookAuthorReview';
import BookCardHeader from 'rebook/apps/base/components/BookCardHeader';
import TextTruncate from 'rebook/apps/base/components/TextTruncate';
import FormattedDateTime from 'rebook/apps/base/components/FormattedDateTime';
import SocialShareMenu from 'rebook/apps/base/components/SocialShareMenu';
import SeoLink from 'rebook/apps/base/components/SeoLink';
import { Review } from 'rebook/apps/books/models';
import Article from 'rebook/apps/base/components/Article';

import styles from './style.scss';


const BookReview = ({ review, theme, isBookHeader, noTruncate, isAuthor, isDetailPage }) => {
  const { book_rating: bookRating, username, comment,
    submit_date: submitDate, livelib_url: livelibUrl, avatar, my_review: myReview } = review;
  const name = username ? username : 'Анонимный читатель';
  const ratingText = myReview ? 'Моя оценка' : 'Оценил книгу';
  const theReview = new Review(review);
  const text = noTruncate
    ? ReactHtmlParser(comment)
    : (
      <TextTruncate collapseLabel="Свернуть отзыв">
        {ReactHtmlParser(comment)}
      </TextTruncate>
    );

  return (
    <React.Fragment>
      {myReview && (
        <div
          className={classNames(styles.myReview, isAuthor && styles.isAuthor, 'jest-my-review')}>
          Мой отзыв
        </div>
      )}
      {isBookHeader && (
        <React.Fragment>
          <BookCardHeader withAuthor theme={theme} book={review.book} GACategory="BookReview" />
          <div className={styles.borderLine} />
        </React.Fragment>
      )}
      <div className={classNames(isBookHeader && styles.review, isDetailPage && styles.reviewDetail)}>
        <div className={styles.author}>
          <BookAuthorReview
            imageUrl={avatar}
            name={name}
            bookRating={bookRating}
            ratingText={ratingText}
            isSelfReview={myReview}
            width={40}
            height={40} />
        </div>
        <div>
          <Article>{text}</Article>
          <div className={styles.date}>
            {submitDate &&
            <Link to={theReview.getLink()}>
              <div className={classNames(styles.separator, styles.dateText)}>
                <FormattedDateTime timestamp={submitDate} format="D MMMM YYYY" />
              </div>
            </Link>
            }
            {livelibUrl && (
              <div className={styles.separator}>
                <SeoLink text="LiveLib" url={livelibUrl} />
              </div>
            )}
          </div>
          {(review && review.share_url) && (
            <div className={styles.shareLinks}>
              <SocialShareMenu url={review.share_url} utmCampaign="reviews" imageUrl={review.book.default_cover} />
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

BookReview.propTypes = {
  review: PropTypes.object.isRequired,
  bookRating: PropTypes.number,
  username: PropTypes.string,
  comment: PropTypes.string,
  submitDate: PropTypes.number,
  livelibUrl: PropTypes.string,
  theme: PropTypes.string,
  avatar: PropTypes.string,
  isBookHeader: PropTypes.bool,
  myReview: PropTypes.bool,
  isAuthor: PropTypes.bool,
};

export default BookReview;
